import React from 'react';

import { Add, DirectionsRun, TransferWithinAStation } from '@mui/icons-material';
import { useRecordContext } from 'components/record/useRecordContext';
import { ResourceContextProvider } from 'components/record/ResourceContext';
import { Link } from 'react-router-dom';
import { DateField, ListField } from 'components/list/Fields';
import List from 'components/list/List';
import useIsOrienteering from 'hooks/useIsOrienteering';
import { Button } from 'components/forms/Buttons';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import MoveCompetitorForm from './MoveCompetitorForm';
import ActionMenuItemEdit from 'components/list/actionMenu/ActionMenuItemEdit';

const EventCompetitors = () => {
  const { record: event } = useRecordContext();
  const isOrienteering = useIsOrienteering();

  return (
    <ResourceContextProvider resource="EventCompetitor" params={{ slug: event.slug }}>
      <List
        bulkOptions={false}
        hidePagination
        title="Competitors"
        avatar={<DirectionsRun />}
        refresh
      // toolbar={
      //   <React.Fragment>
      //     {isOrienteering && (
      //       <Button component={Link} to={`/my_events/${event.slug}/si/import`}>
      //         <Add /> Import SI Data XML
      //       </Button>
      //     )}
      //   </React.Fragment>
      // }
      >
        <ListField source="name" label="Competitor" />
        <DateField source="startTime" label="Start" format="HH:mm:ss" />
        <ListField source="subEvent.name" label="Subevent" />
        <ListField source="device.name" label="GPS Device" />
        <ListField source="siCard" label="SI Card" />
        <ActionMenu label="Actions" align="right" width="5%">
          <ActionMenuItemEdit
            label="Move"
            icon={<TransferWithinAStation />}
            confirmContent={<MoveCompetitorForm event={event} />}
            confirmTitle="Move Competitor"
            permission="event:manage_competitors"
          />
        </ActionMenu>
      </List>
    </ResourceContextProvider>
  );
};

export default EventCompetitors;
